module.exports = __webpack_public_path__ + "img/icon_fp_bldg.8f32177f.svg";